import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OnboardingActions, OnboardingActionTypes } from './onboarding.actions';
import {
  Onboarding,
  BirthdateFormat,
  TOSDetailsType
} from './onboarding.models';

interface OnboardingState {
  email: string;
  password: string;
  onboarding: Onboarding;
  selectedTosIndex: number;
  accountDoesntExist: boolean;
  passwordResetIAuth: string;
  birthdateFormat: BirthdateFormat;
  birthdateLabel: string;
  birthdateButton: string;
  userBirthdateMatches: boolean;
  selectedTosDetails: Array<TOSDetailsType>;
  loginTitle: string;
  birthdateLanguage: string;
  swiperNavigateTo: string;
}

export const onboardingInitialState: OnboardingState = {
  email: undefined,
  password: undefined,
  onboarding: undefined,
  selectedTosIndex: undefined,
  accountDoesntExist: undefined,
  passwordResetIAuth: undefined,
  birthdateFormat: undefined,
  birthdateLabel: undefined,
  userBirthdateMatches: undefined,
  birthdateButton: undefined,
  selectedTosDetails: undefined,
  loginTitle: undefined,
  birthdateLanguage: undefined,
  swiperNavigateTo: undefined
};

export function onboardingReducer(
  state = onboardingInitialState,
  action: OnboardingActions
): OnboardingState {
  switch (action.type) {
    case OnboardingActionTypes.SET_EMAIL:
      return { ...state, email: action.payload };

    case OnboardingActionTypes.SET_PASSWORD:
      return { ...state, password: action.payload };

    case OnboardingActionTypes.ACCOUNT_EXISTS:
      return { ...state, accountDoesntExist: !action.payload };

    case OnboardingActionTypes.LOAD_ONBOARDING_SUCCESS:
      return { ...state, onboarding: action.payload };

    case OnboardingActionTypes.SET_SELECTED_TOS_INDEX:
      return { ...state, selectedTosIndex: action.payload };

    case OnboardingActionTypes.LOAD_ONBOARDING_TOS_ITEM_DETAILS_SUCCESS:
      return { ...state, selectedTosDetails: action.payload };

    case OnboardingActionTypes.PASSWORD_RESET_SUCCESS:
      return { ...state, passwordResetIAuth: action.payload };

    case OnboardingActionTypes.PASSWORD_RESET_FOR_ID_FAILED:
      return { ...state, userBirthdateMatches: true };

    case OnboardingActionTypes.PASSWORD_RESET_FOR_ID_BIRTHDATE_ERROR:
      return { ...state, userBirthdateMatches: void 0 };

    case OnboardingActionTypes.SET_BIRTHDATE_FORMAT:
      return { ...state, birthdateFormat: action.payload };

    case OnboardingActionTypes.SET_BIRTHDATE_LABEL:
      return { ...state, birthdateLabel: action.payload };

    case OnboardingActionTypes.SET_BIRTHDATE_BUTTON:
      return { ...state, birthdateButton: action.payload };

    case OnboardingActionTypes.SET_BIRTHDATE_LANGUAGE:
      return { ...state, birthdateLanguage: action.payload };

    case OnboardingActionTypes.SET_LOGIN_TITLE:
      return { ...state, loginTitle: action.payload };

    case OnboardingActionTypes.SET_SWIPER_NAVIGATE_TO:
      return { ...state, swiperNavigateTo: action.payload };

    case OnboardingActionTypes.SET_EMAIL_FORGOT_PASSWORD:
      return { ...state, email: action.payload };

    default:
      return state;
  }
}

const onboardingState = createFeatureSelector<OnboardingState>('onboarding');

export const selectorOnboardingEmail = createSelector(
  onboardingState,
  state => state.email
);

export const selectorOnboardingPassword = createSelector(
  onboardingState,
  state => state.password
);

export const selectorOnboardingAccountDoesntExist = createSelector(
  onboardingState,
  state => state.accountDoesntExist
);

export const selectorOnboardingOnboarding = createSelector(
  onboardingState,
  state => state.onboarding
);

export const selectorOnboardingSelectedTosIndex = createSelector(
  onboardingState,
  state => state.selectedTosIndex
);

export const selectorOnboardingSelectedTosDetails = createSelector(
  onboardingState,
  state => state.selectedTosDetails
);

export const selectorOnboardingPasswordResetIAuth = createSelector(
  onboardingState,
  state => state.passwordResetIAuth
);

export const selectorOnboardingUserBirthdateMatches = createSelector(
  onboardingState,
  state => state.userBirthdateMatches
);

export const selectorOnBoardingBirthdateFormat = createSelector(
  onboardingState,
  state => state.birthdateFormat
);

export const selectorOnBoardingBirthdateLabel = createSelector(
  onboardingState,
  state => state.birthdateLabel
);

export const selectorOnBoardingBirthdateButton = createSelector(
  onboardingState,
  state => state.birthdateButton
);

export const selectorOnBoardingLoginTitle = createSelector(
  onboardingState,
  state => state.loginTitle
);

export const selectorOnBoardingBirthdateLanguage = createSelector(
  onboardingState,
  state => state.birthdateLanguage
);

export const selectorOnBoardingSwiperNavigateTo = createSelector(
  onboardingState,
  state => state.swiperNavigateTo
);
